/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Style "Last Rolls left" text in red within menu items
  function styleLastRollsText() {
    // Target both desktop and mobile menu items
    const navLinks = document.querySelectorAll('.navlink .navtext, .sliderow__title, .navlink--toplevel, mobile-menu a');
    
    navLinks.forEach(function(element) {
      const text = element.textContent;
      
      // Check if the text contains "Last Rolls left" or "Sale 20% OFF"
      if (text.includes('Last Rolls left') || text.includes('Sale 20% OFF')) {
        // Remove all extra spaces and style the text in red
        let styledText = text
          .replace(/\s+/g, ' ')  // Replace all multiple spaces with single space
          .trim();
        
        // Style "Last Rolls left"
        styledText = styledText.replace(/Fall Linen Collection\s+\(Last Rolls left\)/gi, 'Fall Linen Collection&nbsp;<span style="color: #d02a2a;">(Last Rolls left)</span>');
        
        // Style "Sale 20% OFF"
        styledText = styledText.replace(/(Sale 20% OFF)/gi, '<span style="color: #d02a2a;">$1</span>');
        
        element.innerHTML = styledText;
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleLastRollsText);
  } else {
    styleLastRollsText();
  }

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
